import React from 'react';
import { useTranslator } from 'tradera-lang/translate';

const BidsLabel = ({ className, tagName: TagName, count }) => {
    const { t } = useTranslator();
    return (
        <TagName className={className}>
            {t('itemCard_numberOfBidsWithCount', { count })}
        </TagName>
    );
};
BidsLabel.defaultProps = {
    tagName: 'span'
};
export default BidsLabel;
